// extracted by mini-css-extract-plugin
module.exports = {"content":"TripCartAsidePanel_content__fqdnp"};